import AboutBio from '../blocks/about-bio.js';
import BlockContents from '../blocks/contents.js';
import SectionHeading from '../section-heading.js';
import { useLanguage } from '../language-context.js';
import content from '../content.js';

const BlockAbout = () => {
  const { lang } = useLanguage();
  const t = content[lang].about;

  return (
    <section className="about" id="about">
      <SectionHeading number={t.number} title={t.title} />

      <div className="about-columns">
        <AboutBio />
        <BlockContents />
      </div>

    </section>
  );
}

export default BlockAbout;
